<template>
    <div v-if="value">
        <input-text
            label="Rubrik"
            required
            v-model:content="value.title"
        />
        <input-editor
            label="Innehåll"
            required
            v-model:content="value.body"
        />
        <input-editor
            label="Förhandsgranskning"
            v-model:content="value.preview"
        />
    </div>
    <mf-spinner-medium v-else class="w-16 h-8"></mf-spinner-medium>
</template>
<script>
export default {
    props: {
        modelValue: {},
    },
    emits: [
        'update:modelValue'
    ],
    data() {
        return {
            value: null,
        };
    },
    async mounted() {
        this.captureModelValue();
    },
    watch: {
        modelValue() {
            if (JSON.stringify(this.value) === JSON.stringify(this.modelValue)) { return; }
            this.captureModelValue();
        },
        value: {
            handler() {
                this.$emit('update:modelValue', JSON.parse(JSON.stringify(this.value)));
            },
            deep: true
        }
    },
    methods: {
        captureModelValue() {
            const value = this.modelValue ? JSON.parse(JSON.stringify(this.modelValue)) : {};
            if (!value.title) { value.title = null; }
            if (!value.body) { value.body = null; }
            this.value = value;
        }
    },
}
</script>
